import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import env from '@tencent/vft-common/env';
if (process.env.NODE_ENV === 'production') {
  Raven.config('https://f3018acc286e4e05983da6513a59554d@report.url.cn/sentry/533', {
    release: '1',
    ignoreErrors: ['WebViewJavascriptBridge', 'WeixinJSBridge is not defined', /Script error.*/],
    sampleRate: 0.1 // 采样率
  }).addPlugin(RavenVue, Vue).install().setExtraContext({
    env: "".concat(env.device, ".").concat(env.app)
  });
}